import {Button, message, Modal} from 'antd';
import {CreateMasterAccountUserInput, useCreateMasterAccountUserMutation} from 'api/generated';
import {AnchorLink, PhoneNumberInput} from 'components';
import {Formik, FormikHelpers} from 'formik';
import {Form, FormItem, Input} from 'formik-antd';
import React, {useState} from 'react';
import * as yup from 'yup';
import {authorizedUsersQuery} from '../../../api/queries';

type Props = {
  accountId: string;
  settings?: boolean;
};

export const CreateMasterAccountUser: React.FC<Props> = ({accountId, settings = false}) => {
  const [isOpen, setOpen] = useState(false);
  const [createMasterAccountUser] = useCreateMasterAccountUserMutation({
    updateQuery: {query: authorizedUsersQuery, variables: {accountId}}
  });

  const handleSubmit = async (
    input: CreateMasterAccountUserInput,
    {setSubmitting, resetForm}: FormikHelpers<CreateMasterAccountUserInput>
  ) => {
    try {
      await createMasterAccountUser({
        variables: {
          input: {
            ...input,
            accountId
          }
        }
      });
      setOpen(false);
      message.success('Master account user created successfully.');
      resetForm();
    } finally {
      setSubmitting(false);
    }
  };

  const validationSchema = yup.object().shape({
    name: yup.string().required('Name is required'),
    email: yup.string().email('Invalid email').required('Email is required'),
    phoneNumber: yup
      .string()
      .matches(/^\+?\d{1,15}$/, 'Phone number is not valid')
      .required('Phone number is required')
  });

  return (
    <>
      {settings ? (
        <Button type="primary" onClick={() => setOpen(true)}>
          Add new user
        </Button>
      ) : (
        <AnchorLink onClick={() => setOpen(true)}>Add new user</AnchorLink>
      )}
      <Formik<CreateMasterAccountUserInput>
        onSubmit={handleSubmit}
        initialValues={{
          email: '',
          name: '',
          phoneNumber: ''
        }}
        validationSchema={validationSchema}>
        {({handleSubmit, isSubmitting, resetForm}) => (
          <Modal
            open={isOpen}
            title="Add new authorized user"
            okText="Add"
            cancelText="Cancel"
            confirmLoading={isSubmitting}
            onOk={() => handleSubmit()}
            onCancel={() => {
              setOpen(false);
              resetForm();
            }}>
            <Form layout="vertical">
              <FormItem hasFeedback={false} name="email" label="User email">
                <Input name="email" placeholder="email@example.com" type="email" />
              </FormItem>
              <FormItem hasFeedback={false} name="name" label="Name">
                <Input name="name" placeholder="John Doe" />
              </FormItem>
              <FormItem hasFeedback={false} name="phoneNumber" label="Phone number">
                <PhoneNumberInput name="phoneNumber" />
              </FormItem>
              <input type="submit" value="submit" hidden />
            </Form>
          </Modal>
        )}
      </Formik>
    </>
  );
};
